import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import BlurBg from "../../../assets/ImageEditing/images/api-blur-bg.jpg";
import Crop from "../../../assets/ImageEditing/images/api-crop-image.jpg";
import ImageToPSD from "../../../assets/ImageEditing/images/api-delayer-image.jpg";
import Eraser from "../../../assets/ImageEditing/images/api-erase-elements.jpg";
import EraseForeground from "../../../assets/ImageEditing/images/api-erase-foreground.jpg";
import ExpandImage from "../../../assets/ImageEditing/images/api-expand-image.jpg";
import GenFill from "../../../assets/ImageEditing/images/api-genfill.jpg";
import IncreaseRes from "../../../assets/ImageEditing/images/api-increase-resolution.jpg";
import MaskGenerator from "../../../assets/ImageEditing/images/api-masks-generator.jpg";
import ModifyPresenter from "../../../assets/ImageEditing/images/api-modify-presenter.jpg";
import RemoveBg from "../../../assets/ImageEditing/images/api-remove-bg.jpg";
import ReplaceBg from "../../../assets/ImageEditing/images/api-replace-bg.jpg";
import { ConsoleAPICardProps } from "../../../components/Home/API/Cards/Card/ConsoleAPICard";
import ConsoleAPICards from "../../../components/Home/API/Cards/ConsoleAPICards";
import ConsoleAPILayout from "../../../components/Home/API/ConsoleAPILayout";
import BriaButton from "../../../components/common/BriaButton/BriaButton";
import LinkConstants from "../../../constants/LinkConstants";

const ImageEditingAPI = () => {
	const { t } = useTranslation("translation", { keyPrefix: "imageEditing.api" });

	const openDocs = (link: string) => window.open(link, "_blank");

	const imageEditingApiCards: ConsoleAPICardProps[] = [
		{
			image: GenFill,
			header: t("cards.genFill.header"),
			description: t("cards.genFill.description"),
			buttons: (
				<BriaButton buttonType="textSmall" onClick={() => openDocs(LinkConstants.IMAGE_EDITING.GEN_FILL.DOCS)}>
					{t("cards.genFill.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.IMAGE_EDITING.GEN_FILL.DOCS),
		},
		{
			image: Eraser,
			header: t("cards.eraser.header"),
			description: t("cards.eraser.description"),
			buttons: (
				<BriaButton buttonType="textSmall" onClick={() => openDocs(LinkConstants.IMAGE_EDITING.ERASER.DOCS)}>
					{t("cards.eraser.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.IMAGE_EDITING.ERASER.DOCS),
		},
		{
			image: EraseForeground,
			header: t("cards.eraseForeground.header"),
			description: t("cards.eraseForeground.description"),
			buttons: (
				<BriaButton
					buttonType="textSmall"
					onClick={() => openDocs(LinkConstants.IMAGE_EDITING.ERASE_FOREGROUND.DOCS)}
				>
					{t("cards.eraseForeground.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.IMAGE_EDITING.ERASE_FOREGROUND.DOCS),
		},
		{
			image: ReplaceBg,
			header: t("cards.replaceBg.header"),
			description: t("cards.replaceBg.description"),
			buttons: (
				<BriaButton
					buttonType="textSmall"
					onClick={() => openDocs(LinkConstants.IMAGE_EDITING.REPLACE_BACKGROUND.DOCS)}
				>
					{t("cards.replaceBg.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.IMAGE_EDITING.REPLACE_BACKGROUND.DOCS),
		},
		{
			image: RemoveBg,
			header: t("cards.removeBg.header"),
			description: t("cards.removeBg.description"),
			buttons: (
				<BriaButton buttonType="textSmall" onClick={() => openDocs(LinkConstants.IMAGE_EDITING.GEN_FILL.DOCS)}>
					{t("cards.removeBg.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.IMAGE_EDITING.GEN_FILL.DOCS),
		},
		{
			image: BlurBg,
			header: t("cards.blurBg.header"),
			description: t("cards.blurBg.description"),
			buttons: (
				<BriaButton
					buttonType="textSmall"
					onClick={() => openDocs(LinkConstants.IMAGE_EDITING.BLUR_BACKGROUND.DOCS)}
				>
					{t("cards.blurBg.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.IMAGE_EDITING.BLUR_BACKGROUND.DOCS),
		},
		{
			image: ExpandImage,
			header: t("cards.expandImage.header"),
			description: t("cards.expandImage.description"),
			buttons: (
				<BriaButton
					buttonType="textSmall"
					onClick={() => openDocs(LinkConstants.IMAGE_EDITING.EXPAND_IMAGE.DOCS)}
				>
					{t("cards.expandImage.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.IMAGE_EDITING.EXPAND_IMAGE.DOCS),
		},
		{
			image: IncreaseRes,
			header: t("cards.increaseRes.header"),
			description: t("cards.increaseRes.description"),
			buttons: (
				<BriaButton
					buttonType="textSmall"
					onClick={() => openDocs(LinkConstants.IMAGE_EDITING.INCREASE_RESOLUTION.DOCS)}
				>
					{t("cards.increaseRes.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.IMAGE_EDITING.INCREASE_RESOLUTION.DOCS),
		},
		{
			image: ImageToPSD,
			header: t("cards.imageToPSD.header"),
			description: t("cards.imageToPSD.description"),
			buttons: (
				<BriaButton
					buttonType="textSmall"
					onClick={() => openDocs(LinkConstants.IMAGE_EDITING.IMAGE_TO_PSD.DOCS)}
				>
					{t("cards.imageToPSD.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.IMAGE_EDITING.IMAGE_TO_PSD.DOCS),
		},
		{
			image: Crop,
			header: t("cards.crop.header"),
			description: t("cards.crop.description"),
			buttons: (
				<BriaButton buttonType="textSmall" onClick={() => openDocs(LinkConstants.IMAGE_EDITING.CROP.DOCS)}>
					{t("cards.crop.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.IMAGE_EDITING.CROP.DOCS),
		},
		{
			image: ModifyPresenter,
			header: t("cards.modifyPresenter.header"),
			description: t("cards.modifyPresenter.description"),
			buttons: (
				<BriaButton
					buttonType="textSmall"
					onClick={() => openDocs(LinkConstants.IMAGE_EDITING.MODIFY_PRESENTER.DOCS)}
				>
					{t("cards.modifyPresenter.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.IMAGE_EDITING.MODIFY_PRESENTER.DOCS),
		},
		{
			image: MaskGenerator,
			header: t("cards.maskGenerator.header"),
			description: t("cards.maskGenerator.description"),
			buttons: (
				<BriaButton
					buttonType="textSmall"
					onClick={() => openDocs(LinkConstants.IMAGE_EDITING.MASK_GENERATOR.DOCS)}
				>
					{t("cards.maskGenerator.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.IMAGE_EDITING.MASK_GENERATOR.DOCS),
		},
	];

	return (
		<ConsoleAPILayout description={t("description")}>
			<ConsoleAPICards cards={imageEditingApiCards} />
		</ConsoleAPILayout>
	);
};

export default observer(ImageEditingAPI);
